export const districtData = {
    "colombo": {
        name: "Colombo",
        description: "The commercial heart of Sri Lanka, blending colonial history with a rapidly growing modern skyline.",
        topPlaces: ["Galle Face Green", "Lotus Tower", "Gangaramaya Temple", "National Museum"],
        topJungles: ["Beddagana Wetland Park", "Talangama Wetland"],
        image: "https://images.unsplash.com/photo-1588258524675-614293c66812?q=80&w=2070&auto=format&fit=crop"
    },
    "kandy": {
        name: "Kandy",
        description: "The spiritual capital, set in the hills and home to the sacred Temple of the Tooth.",
        topPlaces: ["Temple of the Tooth", "Peradeniya Botanical Gardens", "Kandy Lake"],
        topJungles: ["Udawatta Kele Sanctuary", "Knuckles Mountain Range"],
        image: "https://images.unsplash.com/photo-1546255140-59f77e682d3f?q=80&w=2070&auto=format&fit=crop"
    },
    "galle": {
        name: "Galle",
        description: "A historic Dutch fort city on the southwest coast with cobbled streets and colonial charm.",
        topPlaces: ["Galle Fort", "Japanese Peace Pagoda", "Unawatuna Beach"],
        topJungles: ["Hiyare Reservoir Rainforest", "Kottawa Forest"],
        image: "https://images.unsplash.com/photo-1603566234384-9ae43632943e?q=80&w=2070&auto=format&fit=crop"
    },
    "ampara": {
        name: "Ampara",
        description: "An agricultural and wildlife hub in the east, famous for rice cultivation and elephant sightings.",
        topPlaces: ["Deegawapiya Stupa", "Gal Oya National Park", "Buddhangala Monastary"],
        topJungles: ["Gal Oya Valley", "Senanayake Samudra Reserve"],
        image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778eff?q=80&w=2070&auto=format&fit=crop"
    },
    "anuradhapura": {
        name: "Anuradhapura",
        description: "The first capital of ancient Sri Lanka, sprawling with massive dagobas and sacred ruins.",
        topPlaces: ["Ruwanwelisaya", "Jaya Sri Maha Bodhi", "Isurumuniya"],
        topJungles: ["Wilpattu National Park", "Ritigala Strict Nature Reserve"],
        image: "https://images.unsplash.com/photo-1620619767323-b95a89183081?q=80&w=2070&auto=format&fit=crop"
    },
    "badulla": {
        name: "Badulla",
        description: "A misty mountain town marking the end of the scenic railway line, surrounded by tea estates.",
        topPlaces: ["Demodara Nine Arch Bridge", "Muthiyangana Raja Maha Viharaya", "Dunhinda Falls"],
        topJungles: ["Namunukula Mountain Range"],
        image: "https://images.unsplash.com/photo-1544155101-77b311fc1f42?q=80&w=2070&auto=format&fit=crop"
    },
    "batticaloa": {
        name: "Batticaloa",
        description: "The city of 'singing fish', known for its lighthouse, calm lagoons, and coral reefs.",
        topPlaces: ["Batticaloa Fort", "Kallady Bridge", "Passikudah Beach"],
        topJungles: ["Vakarai Eco Reserve"],
        image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?q=80&w=1974&auto=format&fit=crop"
    },
    "gampaha": {
        name: "Gampaha",
        description: "A major commercial and industrial district hosting beautiful botanical gardens and temples.",
        topPlaces: ["Henarathgoda Botanical Garden", "Maligathenna Temple", "Pilikuthuwa"],
        topJungles: ["Muthurajawela Marsh"],
        image: "https://images.unsplash.com/photo-1588258524675-614293c66812?q=80&w=2070&auto=format&fit=crop"
    },
    "hambantota": {
        name: "Hambantota",
        description: "The gateway to biological diversity in the south, featuring massive national parks and arid landscapes.",
        topPlaces: ["Yala National Park", "Bundala National Park", "Ridiyagama Safari Park"],
        topJungles: ["Kumana National Park"],
        image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778eff?q=80&w=2070&auto=format&fit=crop"
    },
    "jaffna": {
        name: "Jaffna",
        description: "The northern cultural capital, unique for its palmyrah trees, vibrant kovils, and historic islands.",
        topPlaces: ["Nallur Kovil", "Jaffna Fort", "Casuarina Beach"],
        topJungles: ["Chundikulam National Park"],
        image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?q=80&w=1974&auto=format&fit=crop"
    },
    "kalutara": {
        name: "Kalutara",
        description: "Famous for its massive hollow dagoba and its golden beaches lined with palm trees.",
        topPlaces: ["Kalutara Bodhiya", "Richmond Castle", "Calido Beach"],
        topJungles: ["Sinharaja Forest Range (Access points)"],
        image: "https://images.unsplash.com/photo-1603566234384-9ae43632943e?q=80&w=2070&auto=format&fit=crop"
    },
    "kegalle": {
        name: "Kegalle",
        description: "A scenic transition between lowlands and mountains, home to elephant conservation sites.",
        topPlaces: ["Pinnawala Elephant Orphanage", "Pinnawala Open Zoo", "Bible Rock"],
        topJungles: ["Dedigama Nature Reserve"],
        image: "https://images.unsplash.com/photo-1546255140-59f77e682d3f?q=80&w=2070&auto=format&fit=crop"
    },
    "kilinochchi": {
        name: "Kilinochchi",
        description: "A northern hub rebuild over decades, known for its vast wetlands and agricultural resilience.",
        topPlaces: ["Iranamadu Tank", "Kilinochchi War Memorial"],
        topJungles: ["Chundikulam Nature Reserve"],
        image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?q=80&w=1974&auto=format&fit=crop"
    },
    "kurunegala": {
        name: "Kurunegala",
        description: "The city of the Elephant Rock, a significant historical kingdom surrounded by coconut plantations.",
        topPlaces: ["Athugala Elephant Rock", "Ridi Vihara", "Yapahuwa Rock Fortress"],
        topJungles: ["Munnesswaram Nature Buffer"],
        image: "https://images.unsplash.com/photo-1620619767323-b95a89183081?q=80&w=2070&auto=format&fit=crop"
    },
    "mannar": {
        name: "Mannar",
        description: "A historic dry-zone island town famous for its ancient baobab trees and flamingo migrations.",
        topPlaces: ["Mannar Fort", "Tirukketiswaram Temple", "Keeri Beach"],
        topJungles: ["Madhu Road Sanctuary"],
        image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778eff?q=80&w=2070&auto=format&fit=crop"
    },
    "matale": {
        name: "Matale",
        description: "A central hub for culture and spice, the gateway to the Cultural Triangle's top landmarks.",
        topPlaces: ["Sigiriya", "Dambulla Golden Temple", "Aluvihara Rock Temple"],
        topJungles: ["Wasgamuwa National Park"],
        image: "https://images.unsplash.com/photo-1620619767323-b95a89183081?q=80&w=2070&auto=format&fit=crop"
    },
    "matara": {
        name: "Matara",
        description: "The southern commercial hub, home to old forts and the island's tallest lighthouse.",
        topPlaces: ["Dondra Head Lighthouse", "Polhena Beach", "Matara Fort"],
        topJungles: ["Sinharaja Southern Access"],
        image: "https://images.unsplash.com/photo-1603566234384-9ae43632943e?q=80&w=2070&auto=format&fit=crop"
    },
    "moneragala": {
        name: "Moneragala",
        description: "A wild and rugged district, home to a huge portion of Sri Lanka's protected jungles.",
        topPlaces: ["Kataragama Sacred City", "Maligawila Buddha Statue", "Gal Oya Border"],
        topJungles: ["Yala Blocks III/IV", "Gal Oya National Park"],
        image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778eff?q=80&w=2070&auto=format&fit=crop"
    },
    "mullativu": {
        name: "Mullativu",
        description: "A northern coastal district known for its lagoons and strategic historical sites.",
        topPlaces: ["Nanthikadal Lagoon", "Mullaitivu Beach"],
        topJungles: ["Giant's Tank Sanctuary Buffer"],
        image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?q=80&w=1974&auto=format&fit=crop"
    },
    "nuwara-eliya": {
        name: "Nuwara-eliya",
        description: "Little England, the highest town in the country surrounded by world-class tea plantations.",
        topPlaces: ["Gregory Lake", "Horton Plains", "Victoria Park"],
        topJungles: ["Galway's Land National Park", "Horton Plains National Park"],
        image: "https://images.unsplash.com/photo-1544155101-77b311fc1f42?q=80&w=2070&auto=format&fit=crop"
    },
    "polonnaruwa": {
        name: "Polonnaruwa",
        description: "Medieval capital of Sri Lanka, a UNESCO site with incredible irrigation and architectural marvels.",
        topPlaces: ["Parakrama Samudra", "Gal Vihara", "Polonnaruwa Ruins"],
        topJungles: ["Minneriya National Park", "Kaudulla National Park"],
        image: "https://images.unsplash.com/photo-1620619767323-b95a89183081?q=80&w=2070&auto=format&fit=crop"
    },
    "puttalam": {
        name: "Puttalam",
        description: "A coastal district known for salt pans, wind farms, and Sri Lanka's largest national park.",
        topPlaces: ["Kalpitiya Lagoon", "St. Anne's Church", "Thabbowa Tank"],
        topJungles: ["Wilpattu National Park"],
        image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778eff?q=80&w=2070&auto=format&fit=crop"
    },
    "ratnapura": {
        name: "Ratnapura",
        description: "The City of Gems, the primary source of Sri Lanka's world-famous sapphires and rubies.",
        topPlaces: ["Maha Saman Devalaya", "Gem Museums", "Bopath Ella Falls"],
        topJungles: ["Sinharaja Rain Forest", "Udawalawe National Park"],
        image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778eff?q=80&w=2070&auto=format&fit=crop"
    },
    "trincomalee": {
        name: "Trincomalee",
        description: "One of the world's finest natural harbors, featuring blue waters and incredible marine life.",
        topPlaces: ["Nilaveli Beach", "Koneswaram Temple", "Pigeon Island"],
        topJungles: ["Somawathiya Nature Reserve Buffer"],
        image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?q=80&w=1974&auto=format&fit=crop"
    },
    "vavuniya": {
        name: "Vavuniya",
        description: "A cultural melting pot in the north central region, serving as a gateway to the north.",
        topPlaces: ["Madukanda Temple", "Kandhaswamy Kovil"],
        topJungles: ["Vavuniya Forest Corridors"],
        image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?q=80&w=1974&auto=format&fit=crop"
    }
};
